module.exports = "<pre>{{user | json}}</pre>\n"